import { render, staticRenderFns } from "./tos.vue?vue&type=template&id=3d2ae8b4&"
import script from "./tos.vue?vue&type=script&lang=js&"
export * from "./tos.vue?vue&type=script&lang=js&"
import style0 from "./tos.vue?vue&type=style&index=0&id=3d2ae8b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports